module.exports = __webpack_public_path__ + "static/hallid.ai-97f1c1ca46b6a3e97b6c93486f2115ac.jpg";